(function ($) {
    'use strict';

    $(document).ready(function () {
        let userData = window.awGetUserData(),
                userCookie = window.awGetUserCookie();
        if (userData && userData.e_mail && userCookie && userCookie.api_guid && userCookie.acc_check && userCookie.acc_check_cw) {
            if ($('.secondary-navigation a[href*="f=custcare"]').length > 0) {
                if(!userCookie.sub_type || userCookie.sub_type=="R"){
                    $('.secondary-navigation a[href*="f=custcare"]').remove();
                }
            if ($('.secondary-navigation a[href*="f=custcare"]').length > 0) {
                $('.secondary-navigation a[href*="f=custcare"]').each(function () {
                    let subscriptionURL = $(this).attr('href');
                    if (subscriptionURL && subscriptionURL.indexOf('?') === -1) {
                        subscriptionURL += '?';
                    } else {
                        subscriptionURL += '&';
                    }

                    // cwRedirectURL += 'cg=' + userCookie.acc_check_cw + encodeURI( '|' ) + userCookie.api_guid.replace(/-/g,'' );
                    subscriptionURL += 'cg=' + userCookie.acc_check_cw + '|' + userCookie.api_guid.replace(/-/g, '');
                    $(this).attr('href', subscriptionURL);

                })
            }
        }
        }
    })

})(jQuery);
